// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__c2ca07cf0d316f9d0f44","cls2":"NewsInteractionBar-cls2___366bff834cdc005d47d NewsInteractionBar-cls1__c2ca07cf0d316f9d0f44"};